import { Breadcrumbs } from '@mantine/core';
export const breadcrumbsProps = Breadcrumbs.extend({
    styles: {
        root: { color: 'var(--brand-body-dark-1)' },
        breadcrumb: { fontSize: 'var(--mantine-font-size-sm)' },
        separator: { fontSize: 'var(--mantine-font-size-sm)', margin: '0 0.5rem' },
    },
});
